import React from 'react';

function Report() {
  return (
    <div style={{ textAlign: 'center', marginTop: '2rem' }}>
      <h1>Welcome to the Report Page!</h1>
      <p>Here you can view and manage your reports.</p>
      <iframe width="95%" height="600" src="https://analytics.zoho.com/open-view/2658616000009548512/5c43a4e6da1383f64abc3dcd4a111f8b"></iframe>
    </div>
  );
}

export default Report;
